/* STYRKR FUEL TOOL — DATA LAYER
   Citations, product catalog, plan generator algorithm.
   See RESEARCH_NOTES.md for the science backbone.
   Namespace: window.STYRKR_FUEL_V7_DATA — read-only. */

(function (window) {
  'use strict';

  /* CSP-safe page housekeeping (runs from an external asset, so it survives the
     live theme's inline-script Content-Security-Policy):
       1. noindex — this is a hidden athlete-test page, keep it out of search.
       2. ApexCharts fallback — load the CDN only if the host theme doesn't already
          provide it (the live + Jovan themes do, so this rarely fires). */
  try {
    var d = window.document;
    if (d && d.head) {
      if (!d.querySelector('meta[name="robots"][data-ft]')) {
        var rm = d.createElement('meta');
        rm.name = 'robots'; rm.content = 'noindex,nofollow'; rm.setAttribute('data-ft', '1');
        d.head.appendChild(rm);
      }
      if (typeof window.ApexCharts === 'undefined' && !d.getElementById('ft-apex-cdn')) {
        var s = d.createElement('script');
        s.id = 'ft-apex-cdn';
        s.src = 'https://cdn.jsdelivr.net/npm/apexcharts@3.45.1/dist/apexcharts.min.js';
        d.head.appendChild(s);
      }
    }
  } catch (e) { /* never block the tool on housekeeping */ }

  /* ─────────────────────────────────────────────
     CITATIONS — mirror of RESEARCH_NOTES.md
  ───────────────────────────────────────────── */
  const CITATIONS = {
    1: {
      authors: 'Jeukendrup, A.E.',
      year: 2014,
      title: 'A step towards personalized sports nutrition: carbohydrate intake during exercise',
      journal: 'Sports Medicine',
      vol: '44(Suppl 1)',
      pages: 'S25–S33',
      tag: 'Carb tier ladder',
      url: 'https://doi.org/10.1007/s40279-014-0148-z'
    },
    2: {
      authors: 'O\u2019Brien, W.J. & Rowlands, D.S.',
      year: 2011,
      title: 'Fructose-maltodextrin ratio in a carbohydrate-electrolyte solution differentially affects exogenous carbohydrate oxidation rate, gut comfort, and performance',
      journal: 'Am J Physiol Gastrointest Liver Physiol',
      vol: '300(1)',
      pages: 'G181–G189',
      tag: 'Dual-carb 1:0.8 ratio',
      url: 'https://doi.org/10.1152/ajpgi.00419.2010'
    },
    3: {
      authors: 'Costa, R.J.S. et al.',
      year: 2017,
      title: 'Systematic review: exercise-induced gastrointestinal syndrome',
      journal: 'Aliment Pharmacol Ther',
      vol: '46(3)',
      pages: '246–265',
      tag: 'Gut training adaptation',
      url: 'https://doi.org/10.1111/apt.14157'
    },
    4: {
      authors: 'Sawka, M.N. et al.',
      year: 2007,
      title: 'ACSM Position Stand: Exercise and fluid replacement',
      journal: 'Med Sci Sports Exerc',
      vol: '39(2)',
      pages: '377–390',
      tag: 'Sweat rate & fluid',
      url: 'https://doi.org/10.1249/mss.0b013e31802ca597'
    },
    5: {
      authors: 'Baker, L.B.',
      year: 2019,
      title: 'Sweating rate and sweat sodium concentration in athletes',
      journal: 'Sports Medicine',
      vol: '49(Suppl 1)',
      pages: 'S111–S128',
      tag: 'Sodium tiers',
      url: 'https://doi.org/10.1007/s40279-019-01044-6'
    },
    6: {
      authors: 'Guest, N.S. et al.',
      year: 2021,
      title: 'ISSN position stand: caffeine and exercise performance',
      journal: 'J Int Soc Sports Nutr',
      vol: '18(1)',
      pages: '1',
      tag: 'Caffeine dosing',
      url: 'https://doi.org/10.1186/s12970-020-00383-4'
    },
    7: {
      authors: 'Maughan, R.J. et al.',
      year: 2018,
      title: 'IOC Consensus Statement: Dietary supplements and the high-performance athlete',
      journal: 'Br J Sports Med',
      vol: '52(7)',
      pages: '439–455',
      tag: 'Race-day consensus',
      url: 'https://doi.org/10.1136/bjsports-2018-099027'
    },
    8: {
      authors: 'Stellingwerff, T. & Cox, G.R.',
      year: 2014,
      title: 'Systematic review: carbohydrate supplementation on exercise performance',
      journal: 'Appl Physiol Nutr Metab',
      vol: '39(9)',
      pages: '998–1011',
      tag: 'Solid food in endurance',
      url: 'https://doi.org/10.1139/apnm-2014-0027'
    },
    9: {
      authors: 'Burke, L.M. & Hawley, J.A.',
      year: 2018,
      title: 'Swifter, higher, stronger: What\u2019s on the menu?',
      journal: 'Science',
      vol: '362(6416)',
      pages: '781–787',
      tag: 'Goal periodisation',
      url: 'https://doi.org/10.1126/science.aau2093'
    },
    10: {
      authors: 'Hew-Butler, T. et al.',
      year: 2015,
      title: 'Third International Exercise-Associated Hyponatremia Consensus Statement',
      journal: 'Clin J Sport Med',
      vol: '25(4)',
      pages: '303–320',
      tag: 'Hyponatraemia risk',
      url: 'https://doi.org/10.1097/JSM.0000000000000221'
    }
  };

  /* ─────────────────────────────────────────────
     PRODUCT CATALOG — live Shopify variant IDs
     Revalidated 2026-06-09 against the styrkr.com storefront (/products/*.js).
       • GEL50 collapsed to a single UK variant (57505165934974) — the old
         per-flavour variant IDs (5679186…) 404'd, which broke the cart.
       • MIX90 + MIX90 Caf are OUT OF STOCK (available:false). The generator
         substitutes MIX60 so it never recommends an unbuyable box; flip these
         back to true (or wire a live availability check) once restocked.
     `available:false` ⇒ generator avoids the product. Missing/`true` ⇒ usable.

     PACK POLICY (Jake, 2026-06-09): retail packs ONLY —
       • BARS / GELS / MIX sachets → 12-boxes only (never BYOB 1x or 6-pack variants)
       • SLT05 → single Box of 6 only
       • SLT+  → 30-sachet box only (never the £4.99 upsell 6-pack)
       • MIX+  → 555g tub (its canonical retail format)
     If a 12-box goes OOS, mark available:false — do NOT swap to a 6-pack.
     TODO: swap GEL30 Caffeine → GEL50 Caffeine when SKU launches.
  ───────────────────────────────────────────── */
  const PRODUCTS = {
    GEL50_BERRY: {
      key: 'GEL50_BERRY',
      family: 'GEL50',
      title: 'GEL50 Dual-Carb Energy Gel',
      shortTitle: 'GEL50',
      handle: 'gel50-dual-carb-energy-gel-citrus-fruits',
      productId: 15740727132542,
      variantId: 57505165934974,
      available: true,
      price: 29.99,
      packSize: 12,
      packLabel: 'Box of 12',
      perUnit: { carbsG: 50, fluidMl: 0, sodiumMg: 100, caffeineMg: 0 },
      caffeinated: false,
      role: 'gel-carb',
      veganFriendly: true
    },
    GEL50_CITRUS: {
      key: 'GEL50_CITRUS',
      family: 'GEL50',
      title: 'GEL50 Dual-Carb Energy Gel',
      shortTitle: 'GEL50',
      handle: 'gel50-dual-carb-energy-gel-citrus-fruits',
      productId: 15740727132542,
      variantId: 57505165934974,
      available: true,
      price: 29.99,
      packSize: 12,
      packLabel: 'Box of 12',
      perUnit: { carbsG: 50, fluidMl: 0, sodiumMg: 100, caffeineMg: 0 },
      caffeinated: false,
      role: 'gel-carb',
      veganFriendly: true
    },
    GEL30_CAF: {
      key: 'GEL30_CAF',
      family: 'GEL30_CAF',
      title: 'GEL30 Caffeine Energy Gel',
      shortTitle: 'GEL30 Caf',
      handle: 'gel30-dual-carb-gel-caffeine',
      productId: 6841530613794,
      variantId: 39841646903330,
      price: 24.99,
      packSize: 12,
      packLabel: 'Box of 12',
      perUnit: { carbsG: 30, fluidMl: 0, sodiumMg: 50, caffeineMg: 75 },
      caffeinated: true,
      role: 'gel-caf',
      veganFriendly: true
    },
    GEL30_NONCAF: {
      key: 'GEL30_NONCAF',
      family: 'GEL30',
      title: 'GEL30 Dual-Carb Energy Gel (L-Citrulline)',
      shortTitle: 'GEL30',
      handle: 'gel30-dual-carb-gel',
      productId: 6901357346850,
      variantId: 40095360778274,
      available: true,
      price: 24.99,
      packSize: 12,
      packLabel: 'Box of 12',
      perUnit: { carbsG: 30, fluidMl: 0, sodiumMg: 50, caffeineMg: 0 },
      caffeinated: false,
      role: 'gel-carb-light',
      veganFriendly: true
    },
    BAR50_VARIETY: {
      key: 'BAR50_VARIETY',
      family: 'BAR50',
      title: 'BAR50 Energy Rice Bars — Variety',
      shortTitle: 'BAR50 Variety',
      handle: 'bar50-variety-pack-energy-bars',
      productId: 15740681716094,
      variantId: 56791600628094,
      price: 29.99,
      packSize: 12,
      packLabel: 'Box of 12',
      perUnit: { carbsG: 50, fluidMl: 0, sodiumMg: 75, caffeineMg: 0 },
      caffeinated: false,
      role: 'bar-solid',
      veganFriendly: true
    },
    MIX60: {
      key: 'MIX60',
      family: 'MIX60',
      title: 'MIX60 Dual-Carb Energy Drink Mix',
      shortTitle: 'MIX60',
      handle: 'mix60-dual-carb-drink',
      productId: 6841476579362,
      variantId: 39845870403618,
      price: 24.99,
      packSize: 12,
      packLabel: 'Box of 12',
      perUnit: { carbsG: 60, fluidMl: 500, sodiumMg: 250, caffeineMg: 0 },
      caffeinated: false,
      role: 'drink-base',
      veganFriendly: true
    },
    MIX90: {
      key: 'MIX90',
      family: 'MIX90',
      title: 'MIX90 Dual-Carb Energy Drink Mix',
      shortTitle: 'MIX90',
      handle: 'mix90-dual-carb-drink',
      productId: 6841441746978,
      variantId: 39845876006946,
      available: false,        // V7-24: OUT OF STOCK on styrkr.com as of 2026-06-09
      price: 29.99,
      packSize: 12,
      packLabel: 'Box of 12',
      perUnit: { carbsG: 90, fluidMl: 700, sodiumMg: 350, caffeineMg: 0 },
      caffeinated: false,
      role: 'drink-high',
      veganFriendly: true
    },
    MIX90_CAF: {
      key: 'MIX90_CAF',
      family: 'MIX90_CAF',
      title: 'MIX90 Caffeine Dual-Carb Energy Drink Mix',
      shortTitle: 'MIX90 Caf',
      handle: 'mix90-caffeine-dual-carb-drink',
      productId: 6841441746978,
      variantId: 39845875646498,
      available: false,        // V7-24: OUT OF STOCK on styrkr.com as of 2026-06-09
      price: 34.99,
      packSize: 12,
      packLabel: 'Box of 12',
      perUnit: { carbsG: 90, fluidMl: 700, sodiumMg: 350, caffeineMg: 100 },
      caffeinated: true,
      role: 'drink-high-caf',
      veganFriendly: true
    },
    SLT_PLUS: {
      key: 'SLT_PLUS',
      family: 'SLT+',
      title: 'SLT+ High-Strength Electrolyte — Orange',
      shortTitle: 'SLT+',
      handle: 'slt-plus',
      productId: 15363667689854,
      // V7-25: the Variety Box variant (55988528480638) went OUT OF STOCK — switched
      // to Orange (in stock). Both are nutritionally identical (1000mg sodium / sachet).
      variantId: 55988528415102,
      available: true,
      price: 29.99,
      packSize: 30,
      packLabel: '30-sachet box',
      perUnit: { carbsG: 0, fluidMl: 500, sodiumMg: 1000, caffeineMg: 0 },
      caffeinated: false,
      role: 'electrolyte',
      veganFriendly: true
    },
    /* V7-25: BAR30, MIX+, SLT05, SLT07 — all verified live + cart-addable on the UK
       storefront (2026-06-09). Nutrition pulled from product pages / nutrition labels. */
    BAR30: {
      key: 'BAR30',
      family: 'BAR30',
      title: 'BAR30 Energy Rice Bar — Variety',
      shortTitle: 'BAR30',
      handle: 'bar30-high-carb-rice-energy-bar',
      productId: 15538357830014,
      variantId: 56124173058430,
      available: true,
      price: 19.99,
      packSize: 12,
      packLabel: 'Box of 12',
      // 30g carb confirmed on product page; sodium ~ proportional to BAR50 (75mg/50g).
      perUnit: { carbsG: 30, fluidMl: 0, sodiumMg: 45, caffeineMg: 0 },
      caffeinated: false,
      role: 'bar-solid',
      veganFriendly: true
    },
    MIX_PLUS: {
      key: 'MIX_PLUS',
      family: 'MIX+',
      title: 'MIX+ Dual-Carb & Electrolyte Drink Mix — Orange',
      shortTitle: 'MIX+',
      handle: 'mix-dual-carb-electrolyte-mix',
      productId: 15740619981182,
      variantId: 56791346446718,
      available: true,
      price: 19.99,
      packSize: 15,                       // 555g tub ≈ 15 × 37g servings
      packLabel: '555g tub (~15 servings)',
      // Nutrition label (per 37g serving): 30g carb, 360mg sodium, mixed ~750ml.
      perUnit: { carbsG: 30, fluidMl: 750, sodiumMg: 360, caffeineMg: 0 },
      caffeinated: false,
      role: 'drink-base',
      veganFriendly: true
    },
    SLT05: {
      key: 'SLT05',
      family: 'SLT05',
      title: 'SLT05 Quad-Blend Electrolyte Powder',
      shortTitle: 'SLT05',
      handle: 'slt05-quad-blend-electrolyte-powder',
      productId: 14820828283262,
      variantId: 51904798196094,
      available: true,
      price: 8.37,
      packSize: 6,
      packLabel: 'Box of 6',
      // Product page table: 360mg sodium (+K/Mg/Ca), 0 carb, mixed in 500ml.
      perUnit: { carbsG: 0, fluidMl: 500, sodiumMg: 360, caffeineMg: 0 },
      caffeinated: false,
      role: 'electrolyte',
      veganFriendly: true
    },
    SLT07: {
      key: 'SLT07',
      family: 'SLT07',
      title: 'SLT07 Hydration Tablets — Citrus 1000mg',
      shortTitle: 'SLT07',
      handle: 'slt07-hydration-tablets-mild-citrus-1',
      productId: 7201607909410,
      variantId: 41081781977122,
      available: true,
      price: 8.37,
      packSize: 12,
      packLabel: 'Tube of 12',
      // 1000mg sodium per tablet (product name + page), 0 carb, dissolve in ~500ml.
      perUnit: { carbsG: 0, fluidMl: 500, sodiumMg: 1000, caffeineMg: 0 },
      caffeinated: false,
      role: 'electrolyte',
      veganFriendly: true
    }
  };

  /* ─────────────────────────────────────────────
     SPORT / DISCIPLINE PROFILES
  ───────────────────────────────────────────── */
  const DISCIPLINES = {
    road_run:    { label: 'Road Running',    icon: 'run',     fluidFactor: 1.00, solidFoodOk: false, hardLogistics: false },
    trail_run:   { label: 'Trail Running',   icon: 'trail',   fluidFactor: 0.90, solidFoodOk: true,  hardLogistics: true  },
    road_cycle:  { label: 'Road Cycling',    icon: 'bike',    fluidFactor: 1.05, solidFoodOk: true,  hardLogistics: false },
    offroad_cyc: { label: 'Off-Road / MTB',  icon: 'mtb',     fluidFactor: 0.95, solidFoodOk: true,  hardLogistics: true  },
    triathlon:   { label: 'Triathlon',       icon: 'tri',     fluidFactor: 1.00, solidFoodOk: false, hardLogistics: true  },
    ultra:       { label: 'Ultra Running',   icon: 'ultra',   fluidFactor: 0.85, solidFoodOk: true,  hardLogistics: true  }
  };

  const INTENSITY = {
    easy:      { label: 'Easy',      carbMult: 0.75, fluidMult: 0.80, effortPct: 60 },
    steady:    { label: 'Steady',    carbMult: 1.00, fluidMult: 1.00, effortPct: 75 },
    threshold: { label: 'Threshold', carbMult: 1.10, fluidMult: 1.10, effortPct: 90 },
    /* SCI-P1-7: race carbMult bumped from 1.00 → 1.15. Race-pace carb oxidation
       (2.5+ g/min, Burke & Hawley 2018) genuinely exceeds steady. Still clamped
       to gut ceiling, so the headline target only changes if there's headroom. */
    race:      { label: 'Race-pace', carbMult: 1.15, fluidMult: 1.10, effortPct: 95 }
  };

  /* SCI-P0-3: Environmental stress factors per Sawka 2007. Multiplies sweat rate.
     Cool ~15% drier, hot/humid up to 55% wetter than mild. This was the single
     biggest missing input per the audit. */
  const ENV_FACTORS = {
    cool: { label: 'Cool (< 15°C)',        factor: 0.85 },
    mild: { label: 'Mild (15–22°C)',       factor: 1.00 },
    warm: { label: 'Warm (22–28°C)',       factor: 1.25 },
    hot:  { label: 'Hot / humid (> 28°C)', factor: 1.55 }
  };

  /* SCI-P1-6: Goal modifiers — modulate carb intake intent.
     - finish: conservative (just complete safely).
     - pb: full target (race-pace fueling).
     - podium: aggressive — push the gut ceiling.
     - adapt: TRAIN-LOW protocol per Burke & Hawley 2018 (intentional carb restriction
       to stress fat-oxidation pathways during easy/steady training). */
  const GOAL_MODIFIERS = {
    finish: { carbMult: 0.85, label: 'Finish' },
    pb:     { carbMult: 1.00, label: 'PB' },
    podium: { carbMult: 1.10, label: 'Podium' },
    adapt:  { carbMult: 0.50, label: 'Train low (adapt)' }
  };

  const GUT_TIERS = {
    new:         { label: 'New to fueling',   target: 60,  cite: 3 },
    experienced: { label: 'Experienced',      target: 90,  cite: 1 },
    trained:     { label: 'High-carb trained', target: 120, cite: 1 }
  };

  const SODIUM_TIERS = {
    light:    { label: 'Light',      mgPerL: 600,  cite: 5 },
    average:  { label: 'Average',    mgPerL: 700,  cite: 5 },
    salty:    { label: 'Salty',      mgPerL: 1000, cite: 5 },
    very:     { label: 'Very salty', mgPerL: 1300, cite: 5 }
  };

  /* ─────────────────────────────────────────────
     PLAN GENERATOR
     Input → personalised fueling plan
  ───────────────────────────────────────────── */
  function generatePlan(input) {
    const i = Object.assign({
      sport: 'road_cycle',
      durationMin: 240,
      intensity: 'steady',
      weightKg: 75,
      caffeine: 'half',          // 'yes' | 'half' | 'no'
      weighting: 'balanced',     // 'gels' | 'drinks' | 'food' | 'balanced'
      gutTier: 'experienced',    // 'new' | 'experienced' | 'trained'
      sweatRateMlH: null,        // ml/h, optional
      sodiumTier: 'average',     // 'light' | 'average' | 'salty' | 'very'
      ftpW: null,                // cyclists, optional
      thresholdPaceMinKm: null,  // runners, optional
      goal: 'pb',                // SCI-P1-6: now ACTIVE — modulates carb target
      dietary: 'standard',       // SCI-P1-6: now ACTIVE — filters product catalog
      environment: 'mild',       // SCI-P0-3: 'cool'|'mild'|'warm'|'hot' — sweat scaling
      flavour: 'berry'           // 'berry' | 'citrus' (GEL50 flavour pref)
    }, input || {});

    const sport = DISCIPLINES[i.sport] || DISCIPLINES.road_cycle;
    const intensity = INTENSITY[i.intensity] || INTENSITY.steady;
    const gut = GUT_TIERS[i.gutTier] || GUT_TIERS.experienced;
    const sodTier = SODIUM_TIERS[i.sodiumTier] || SODIUM_TIERS.average;
    const env = ENV_FACTORS[i.environment] || ENV_FACTORS.mild;       // SCI-P0-3
    const goalMod = GOAL_MODIFIERS[i.goal] || GOAL_MODIFIERS.pb;       // SCI-P1-6
    const durHrs = i.durationMin / 60;

    /* TARGETS ─────────────────────────────────── */

    /* SCI-P0-1: Duration scalar per Jeukendrup 2014 framework.
       Jeukendrup's actual recommendation is duration-dependent:
         <30 min → 0 g/h (mouth rinse benefit only, no metabolic value)
         30–60 min → 0–25% of tier (low-rate)
         60–150 min → ramp 25% → 100%
         >150 min → full tier (gut ceiling capped)
       Fixes the "60 g/h on a 45-min easy ride" over-fueling bug. */
    const durationScalar = i.durationMin < 30
      ? 0
      : Math.min(1, (i.durationMin - 30) / 120);

    // Carb target: gut tier × intensity × duration scalar × goal modifier.
    // Always clamped to the gut tier ceiling so we never exceed trained tolerance.
    const carbTargetGH = Math.min(
      Math.round(gut.target * intensity.carbMult * durationScalar * goalMod.carbMult),
      gut.target
    );

    // Fluid target: from sweat rate or estimated.
    let sweatRate = i.sweatRateMlH;
    if (!sweatRate) {
      // Estimate: ~10 ml/kg/h baseline × intensity factor × discipline factor × env factor.
      sweatRate = Math.round(10 * i.weightKg * intensity.fluidMult * sport.fluidFactor * env.factor);
    } else {
      // User-provided sweat rate is already real-world calibrated; still scale by env if not mild.
      // Rationale: if the test was done in mild conditions, hot-day plan needs more fluid.
      sweatRate = Math.round(sweatRate * env.factor);
    }
    /* SCI-P0-2: removed the double-application of sport.fluidFactor that was here.
       SIM-R6 FIX: the flat 70% replacement was too conservative for long/hot
       sessions — the 200-athlete sim found 6% of plans finishing above the ACSM
       4% body-mass-loss health threshold, all on 4h+ efforts. The 70% figure is
       a hyponatraemia-safety guideline for typical-length events; for long or hot
       sessions the replacement target scales up toward 90% to keep dehydration in
       check (still below 100% so over-drinking risk stays low). */
    let replacementFactor = 0.70;
    if (durHrs > 3)   replacementFactor += Math.min(0.15, (durHrs - 3) * 0.03);  // +3%/h past 3h, cap +15%
    if (env.factor >= 1.25) replacementFactor += 0.05;                            // warm/hot adds 5%
    replacementFactor = Math.min(0.90, replacementFactor);
    const fluidTargetMlH = Math.round(sweatRate * replacementFactor);

    // Sodium target: sweat rate × sweat sodium concentration × same replacement factor.
    const sodiumTargetMgH = Math.round((sweatRate / 1000) * sodTier.mgPerL * replacementFactor);

    // Caffeine total cap: 4 mg/kg for half-and-half, 5 mg/kg for full caf
    const cafCapMg = i.caffeine === 'no' ? 0
                   : i.caffeine === 'half' ? Math.round(4 * i.weightKg)
                   : Math.round(5 * i.weightKg);

    /* TIMELINE ────────────────────────────────── */
    // Two-phase algorithm:
    //   Phase 1 — Place events using per-hour budget (never exceed gut.target g/h)
    //   Phase 2 — Top up sodium with SLT+ where the gap remains
    // Race mode also gets a pre-race fueling slot at -15 min.

    const isRace = i.sessionType === 'race_day' || i.sessionType === 'race_prep';
    const preStartMin = isRace ? -30 : 0;     // axis floor for charts/timeline
    /* V7-20: PRODUCT SELECTION (replaces the old 4-way weighting). The athlete picks
       which STYRKR families to include on the products screen; we resolve that into
       the eligible SKUs + per-hour ratios, then run the SAME validated budget-walk
       engine below. `i.products` is an array of family keys; empty/absent ⇒ balanced
       default (preserves prior behaviour). */
    const DEFAULT_PRODUCTS = ['MIX60', 'GEL50', 'GEL30', 'BAR50', 'SLT_PLUS'];
    const sel = (Array.isArray(i.products) && i.products.length) ? i.products : DEFAULT_PRODUCTS;
    const hasFam = function (f) { return sel.indexOf(f) !== -1; };

    /* V7-26: CATEGORY ALLOCATION. The picker groups products into BARS / MIXES /
       GELS / ELECTROLYTES; the engine allocates WITHIN each selected category by
       fit — the carb-dense option leads, the lighter option places when an hour's
       remaining gut-ceiling headroom is too tight for the big one. Sold-out SKUs
       never enter a candidate list. */

    // MIXES — candidates ordered carb-dense first: MIX90 (90g) → MIX60 (60g) →
    // MIX+ (30g + 360mg sodium). MIX90 swaps to its caffeinated twin on full-caf plans.
    const selMix90 = hasFam('MIX90');
    const mix90Sku = i.caffeine === 'yes' ? PRODUCTS.MIX90_CAF : PRODUCTS.MIX90;
    const mixCandidates = [];
    if (selMix90 && mix90Sku.available !== false) mixCandidates.push(mix90Sku);
    if (hasFam('MIX60') && PRODUCTS.MIX60.available !== false) mixCandidates.push(PRODUCTS.MIX60);
    if (hasFam('MIX_PLUS') && PRODUCTS.MIX_PLUS.available !== false) mixCandidates.push(PRODUCTS.MIX_PLUS);
    const mixSku = mixCandidates[0] || null;   // preferred bottle (cadence + floor fallback)
    const hasDrink = !!mixSku;

    // BARS — BAR50 (50g) leads, BAR30 (30g) places when only the lighter bolus fits.
    const barCandidates = [];
    if (hasFam('BAR50') && PRODUCTS.BAR50_VARIETY.available !== false) barCandidates.push(PRODUCTS.BAR50_VARIETY);
    if (hasFam('BAR30') && PRODUCTS.BAR30.available !== false) barCandidates.push(PRODUCTS.BAR30);
    const barSku = barCandidates[0] || null;
    const selBar = !!barSku;

    // ELECTROLYTES — strongest selected wins: SLT+ (1000mg sachet + fluid) →
    // SLT07 (1000mg tablet) → SLT05 (360mg quad-blend).
    const sltSku = hasFam('SLT_PLUS') ? PRODUCTS.SLT_PLUS
                 : hasFam('SLT07')    ? PRODUCTS.SLT07
                 : hasFam('SLT05')    ? PRODUCTS.SLT05
                 : null;
    const selSlt = !!sltSku;

    // GELS — GEL50/GEL30 resolved below via caffeine preference (pickGel).
    const selGel50 = hasFam('GEL50');
    const selGel30 = hasFam('GEL30');
    const hasGel   = selGel50 || selGel30;

    // Gels: GEL50 = non-caf carb workhorse; GEL30 = caffeine option + lighter non-caf
    // bolus. Each is null when not selected so the pickers know what's available.
    const gelMain = selGel50 ? (i.flavour === 'citrus' ? PRODUCTS.GEL50_CITRUS : PRODUCTS.GEL50_BERRY)
                  : selGel30 ? PRODUCTS.GEL30_NONCAF
                  : null;
    const gelCaf  = selGel30 ? PRODUCTS.GEL30_CAF : null;
    const gelLight = selGel30 ? PRODUCTS.GEL30_NONCAF : gelMain;   // V7-19 no-caf blend partner

    /* SCI-P1-6: dietary filter. Currently the entire STYRKR range is vegan-friendly
       so this is a no-op at runtime — but the wiring exists so when a non-vegan SKU
       enters the catalog (e.g. a whey-based recovery shake), 'vegan' selection will
       exclude it automatically. The reasoning string also reflects the choice. */
    function dietaryOk(product) {
      if (i.dietary === 'vegan' && !product.veganFriendly) return false;
      return true;
    }

    // Per-hour ratios derived from which CATEGORIES are selected (replaces the fixed
    // weighting profiles). mixPerH = bottles/h, gelPerH/barPerH = events/h. The budget
    // walk still caps every hour at the gut ceiling and tops up to the soft target.
    const profile = (function () {
      var barRatio = (selBar && sport.solidFoodOk && durHrs > 2) ? 0.3 : 0;
      if (hasDrink && hasGel)  return { mixPerH: 0.8, gelPerH: 1.0, barPerH: barRatio };
      if (hasDrink && !hasGel) return { mixPerH: 1.0, gelPerH: 0.0, barPerH: barRatio };
      if (!hasDrink && hasGel) return { mixPerH: 0.0, gelPerH: 1.8, barPerH: barRatio };
      return                        { mixPerH: 0.0, gelPerH: 0.0, barPerH: barRatio };   // bars-only / hydration-only edge
    })();

    // Generate events
    const events = [];
    let totalCarbs = 0, totalFluid = 0, totalSodium = 0, totalCaffeine = 0;
    let gelToggle = 0;

    function pushEvent(ev) {
      events.push(ev);
      totalCarbs += ev.carbs || 0;
      totalFluid += ev.fluid || 0;
      totalSodium += ev.sodium || 0;
      totalCaffeine += ev.caffeine || 0;
    }
    // Budget-aware gel picker: respects caffeine preference AND remaining hour budget.
    // Returns null if no gel fits the budget — caller must break out of its loop.
    function pickGel(remainingBudget) {
      // V7-20: gels may not be selected at all (gelMain/gelCaf/gelLight can be null).
      // Guard every access so a sparse product selection can't crash the budget walk.
      if (!gelMain && !gelCaf && !gelLight) return null;
      const cafFits   = !!gelCaf   && gelCaf.perUnit.carbsG   <= remainingBudget && (totalCaffeine + gelCaf.perUnit.caffeineMg <= cafCapMg);
      const mainFits  = !!gelMain  && gelMain.perUnit.carbsG  <= remainingBudget;
      const lightFits = !!gelLight && gelLight.perUnit.carbsG <= remainingBudget;

      // V7-19: no-caf now BLENDS GEL50 (50g) with the non-caf GEL30 (30g) rather
      // than running GEL50-only. Alternating adds variety, and the lighter gel
      // fits when only a small carb gap remains — better budget use, fewer
      // over-shoots. Handled before the generic early-return so the 30g option
      // can still place when the 50g won't.
      if (i.caffeine === 'no') {
        if (!mainFits && !lightFits) return null;
        if (!mainFits)  return gelLight;
        if (!lightFits) return gelMain;
        const wantLight = gelToggle % 2 === 1;
        gelToggle++;
        return wantLight ? gelLight : gelMain;
      }

      if (!cafFits && !mainFits) return null;

      if (i.caffeine === 'yes') return cafFits ? gelCaf : (mainFits ? gelMain : null);

      // half-and-half: alternate, with budget-aware fallback
      const wantCaf = gelToggle % 2 === 0;
      if (wantCaf && cafFits)   { gelToggle++; return gelCaf; }
      if (!wantCaf && mainFits) { gelToggle++; return gelMain; }
      // First choice doesn't fit — try the other
      if (cafFits)  { gelToggle++; return gelCaf; }
      if (mainFits) { gelToggle++; return gelMain; }
      return null;
    }

    // ── 0. PRE-RACE (race mode + meaningful duration only) ──
    // 30 min pre-start: ~50g carb top-up to peak liver glycogen at gun [7]
    // Conditional: skip on short easy efforts (Burke 2018 — pre-race carb top-up
    // matters for events >90 min at moderate-high intensity).
    // For sub-60 min sessions OR easy <90 min OR new gut tier <90 min, skip pre.
    // For new gut tier 90–120 min, scale to GEL30 (lighter bolus) when caf available;
    // otherwise keep GEL50.
    const preRaceJustified = isRace && !(
      i.durationMin < 60
      || (i.durationMin < 90 && i.intensity === 'easy')
      || (i.durationMin < 90 && i.gutTier === 'new')
    );
    // V7-20: only place a pre-race gel if the athlete actually selected a gel.
    if (preRaceJustified && (gelMain || gelLight || gelCaf)) {
      // Lighter pre-race for beginners / shorter sessions — but only from the
      // selected gels (gelCaf = GEL30 caf, gelLight = lighter non-caf, gelMain = GEL50).
      const wantsLightPre = i.gutTier === 'new' || i.durationMin < 120;
      const preGel = (wantsLightPre && i.caffeine !== 'no' && gelCaf) ? gelCaf
                   : (wantsLightPre && gelLight) ? gelLight
                   : (gelMain || gelLight || gelCaf);
      pushEvent({
        timeMin: -30,
        product: preGel,
        qty: 1,
        carbs: preGel.perUnit.carbsG,
        fluid: 0,
        sodium: preGel.perUnit.sodiumMg,
        caffeine: preGel.perUnit.caffeineMg,
        label: 'Pre-race fuel',
        phase: 'pre'
      });
    }

    // ── 1. PER-HOUR BUDGET WALK ──
    // Each hour gets up to gut.target g/h. MIX seeds the hour, gels top up to soft target.
    const hours = Math.ceil(durHrs);
    const gutCeiling = gut.target;             // hard ceiling per hour
    const hourSoftTarget = carbTargetGH;       // soft target per hour
    const mixSpacingHrs = profile.mixPerH > 0 ? Math.max(1, 1 / profile.mixPerH) : 99;

    // BAR cadence (only solid-food-friendly disciplines, >2h)
    const barEnabled = sport.solidFoodOk && durHrs > 2 && profile.barPerH > 0;
    let nextBarAtMin = barEnabled ? 90 : Infinity;     // first BAR at 1:30 if enabled

    // Triathlon swim guard — no fueling possible during the swim leg.
    // Conservative estimate: swim takes ~12% of total race time across distances
    // (sprint ~10%, Olympic ~14%, 70.3 ~12%, IM ~10%). We skip any in-race events
    // before this minute marker. Drinks-led/all weighting still places a bottle
    // at T1 (swim→bike) which is when bottle access begins.
    const swimGuardMin = i.sport === 'triathlon' ? Math.round(i.durationMin * 0.12) : 0;
    const t1MinForTri = swimGuardMin;     // alias used to align first MIX with T1

    for (let h = 0; h < hours; h++) {
      const hourStart = h * 60;
      const hourEnd = Math.min(i.durationMin, (h + 1) * 60);
      let hourCarbs = 0;
      // For triathlon: skip the entire hour if it's all inside the swim window
      if (i.sport === 'triathlon' && hourEnd <= swimGuardMin) {
        continue;   // no fueling possible during swim
      }

      // Place MIX at the start of the hour if cadence aligns.
      // CLINICAL: MIX90 Caf carries 100mg caffeine per bottle. We MUST enforce the
      // ISSN-derived caf cap here — falling back to the non-caf MIX if a caf bottle
      // would push total caffeine over the cap (Carla 7.69 mg/kg bug, audit S-1).
      if (mixCandidates.length && (h === 0 || (h % Math.round(mixSpacingHrs) === 0))) {
        // V7-26: allocate within MIXES by fit — walk the selected mixes carb-dense
        // first and take the first that (a) respects the ISSN caffeine cap and
        // (b) fits this hour's remaining gut-ceiling headroom. A 60 g/h gut on
        // MIX90+MIX60 gets MIX60; a 90 g/h gut gets MIX90 (when in stock).
        let bottle = null;
        for (let mc = 0; mc < mixCandidates.length; mc++) {
          let cand = mixCandidates[mc];
          if (cand.perUnit.caffeineMg > 0
              && totalCaffeine + cand.perUnit.caffeineMg > cafCapMg) {
            // Caf bottle would bust the cap — try its non-caf twin (same carbs).
            cand = cand === PRODUCTS.MIX90_CAF ? PRODUCTS.MIX90 : null;
            if (!cand || cand.available === false) continue;
          }
          if (hourCarbs + cand.perUnit.carbsG <= gutCeiling) { bottle = cand; break; }
        }
        // Triathlon — push first MIX placement to T1 (after swim) instead of t=0
        const placeAt = (i.sport === 'triathlon' && h === 0) ? swimGuardMin : hourStart;
        if (bottle) {
          pushEvent({
            timeMin: placeAt,
            product: bottle,
            qty: 1,
            carbs: bottle.perUnit.carbsG,
            fluid: bottle.perUnit.fluidMl,
            sodium: bottle.perUnit.sodiumMg,
            caffeine: bottle.perUnit.caffeineMg,
            label: 'Bottle',
            phase: 'in'
          });
          hourCarbs += bottle.perUnit.carbsG;
        }
      }

      // BAR slot: try to place at nextBarAtMin if it falls in this hour.
      // Cadence advances regardless of whether it fit — preserves rhythm across full session.
      if (barEnabled && barCandidates.length && nextBarAtMin >= hourStart && nextBarAtMin < hourEnd) {
        // V7-26: allocate within BARS by fit — BAR50 when the hour still has ≥50g
        // of gut-ceiling headroom, else BAR30 when only the 30g bolus fits.
        const bar = barCandidates.find(function (b) { return hourCarbs + b.perUnit.carbsG <= gutCeiling; });
        const inWindow = nextBarAtMin <= i.durationMin - 30;
        if (bar && inWindow) {
          pushEvent({
            timeMin: nextBarAtMin,
            product: bar,
            qty: 1,
            carbs: bar.perUnit.carbsG,
            fluid: 0,
            sodium: bar.perUnit.sodiumMg,
            caffeine: 0,
            label: 'Bar',
            phase: 'in'
          });
          hourCarbs += bar.perUnit.carbsG;
        }
        nextBarAtMin += 90;     // always advance cadence
      }

      // Top up with gels until hourSoftTarget — never exceed gutCeiling
      let gelsThisHour = 0;
      while (gelsThisHour < 3) {
        if (hourCarbs >= hourSoftTarget) break;
        const remaining = gutCeiling - hourCarbs;
        const gel = pickGel(remaining);
        if (!gel) break;
        const slot = hourStart + Math.round((gelsThisHour + 1) * (60 / 3));
        if (slot >= hourEnd) break;
        pushEvent({
          timeMin: slot,
          product: gel,
          qty: 1,
          carbs: gel.perUnit.carbsG,
          fluid: 0,
          sodium: gel.perUnit.sodiumMg,
          caffeine: gel.perUnit.caffeineMg,
          label: 'Gel',
          phase: 'in'
        });
        hourCarbs += gel.perUnit.carbsG;
        gelsThisHour++;
      }
    }

    // ── 1b. CARB GAP CLOSER (SIM-R9 FIX) ──
    // The per-hour budget walk places fuel on a fixed cadence, which systematically
    // under-delivers on long sessions (the 200-athlete sim found 3.5% finishing >100g
    // behind target — all 4h+ efforts). This pass compares total carbs delivered to
    // the full target and tops up with gels in any hour that still has headroom under
    // the gut ceiling, until the gap closes or the plan is physically full.
    (function closeCarbGap() {
      const carbTarget = carbTargetGH * durHrs;
      function totalDelivered() { return events.reduce(function (s, e) { return s + (e.carbs || 0); }, 0); }
      let gap = carbTarget - totalDelivered();
      if (gap <= 15) return;                  // within tolerance — nothing to do

      // PHASE A — MIX60 → MIX90 upgrade (SIM-R9 fix).
      // The dominant deficit driver: weightings that seed an hour with MIX60 (60g)
      // can't pack a 50g GEL50 into the 30g headroom under a 90g ceiling, and STYRKR
      // has no non-caf gel smaller than 50g. Upgrading the bottle in-place adds
      // exactly +30g carbs (+200ml fluid, +100mg sodium) and fills the hour to the
      // ceiling with zero extra events. Done first because it's the most carb-dense
      // way to close the gap.
      // V7-20/V7-24: only upgrade if MIX90 is both SELECTED and IN STOCK — otherwise
      // this injects an unselected / sold-out box that the cart can't add (latent bug).
      const canUpgradeMix = selMix90 && PRODUCTS.MIX90.available !== false;
      for (let h = 0; canUpgradeMix && h < hours && gap > 15; h++) {
        const hStart = h * 60, hEnd = Math.min(i.durationMin, (h + 1) * 60);
        if (i.sport === 'triathlon' && hEnd <= swimGuardMin) continue;
        const hourEvents = events.filter(function (e) { return e.timeMin >= hStart && e.timeMin < hEnd; });
        const hourCarbs = hourEvents.reduce(function (s, e) { return s + (e.carbs || 0); }, 0);
        const mix60 = hourEvents.find(function (e) { return e.product.key === 'MIX60'; });
        if (mix60 && (hourCarbs - 60 + 90) <= gutCeiling) {
          const up = PRODUCTS.MIX90;          // non-caf upgrade — never inject surprise caffeine
          const dC = up.perUnit.carbsG  - mix60.carbs;
          const dF = up.perUnit.fluidMl - mix60.fluid;
          const dS = up.perUnit.sodiumMg - mix60.sodium;
          mix60.product = up;
          mix60.carbs  = up.perUnit.carbsG;
          mix60.fluid  = up.perUnit.fluidMl;
          mix60.sodium = up.perUnit.sodiumMg;
          // Keep running totals in sync — the SLT+ top-up below reads totalSodium/totalFluid.
          totalCarbs += dC; totalFluid += dF; totalSodium += dS;
          gap = carbTarget - totalDelivered();
        }
      }
      if (gap <= 15) return;

      // PHASE B — gel top-ups in any remaining headroom.
      let guard = 0;
      while (gap > 15 && guard < 60) {
        guard++;
        // Find the hour with the most headroom under the gut ceiling.
        let bestHour = -1, bestHeadroom = 0;
        for (let h = 0; h < hours; h++) {
          const hStart = h * 60, hEnd = Math.min(i.durationMin, (h + 1) * 60);
          // Skip the triathlon swim window — no fuelling possible.
          if (i.sport === 'triathlon' && hEnd <= swimGuardMin) continue;
          const hourCarbs = events
            .filter(function (e) { return e.timeMin >= hStart && e.timeMin < hEnd; })
            .reduce(function (s, e) { return s + (e.carbs || 0); }, 0);
          const headroom = gutCeiling - hourCarbs;
          if (headroom > bestHeadroom) { bestHeadroom = headroom; bestHour = h; }
        }
        if (bestHour < 0 || bestHeadroom < 20) break;   // nowhere left with room for a gel

        const gel = pickGel(bestHeadroom);
        if (!gel) break;                                 // caf cap / budget exhausted

        // Place the gel at a free-ish slot inside the chosen hour.
        const hStart = bestHour * 60, hEnd = Math.min(i.durationMin, (bestHour + 1) * 60);
        const existing = events.filter(function (e) { return e.timeMin >= hStart && e.timeMin < hEnd; }).length;
        let slot = hStart + Math.round(((existing % 3) + 1) * (60 / 4));
        if (slot >= hEnd) slot = hStart + Math.round((hEnd - hStart) / 2);
        // Don't fuel in the final 15 min (no point — won't oxidise before the line).
        if (slot > i.durationMin - 15) break;

        pushEvent({
          timeMin: slot,
          product: gel,
          qty: 1,
          carbs: gel.perUnit.carbsG,
          fluid: 0,
          sodium: gel.perUnit.sodiumMg,
          caffeine: gel.perUnit.caffeineMg,
          label: 'Gel',
          phase: 'in'
        });
        gap = carbTarget - totalDelivered();
      }
    })();

    // ── 2. SLT+ — close BOTH the sodium AND fluid gaps (SIM-R6 fix) ──
    // Each SLT+ delivers 500 ml fluid + 1000 mg sodium. The old version sized the
    // SLT+ count on the sodium gap alone, which left long sessions short on fluid
    // (the sim found 6% finishing >4% body-mass loss — ACSM health-risk zone). Now
    // we size on whichever gap is bigger so both close, then cap so total sodium
    // never exceeds 1.5× need (Hew-Butler: excess sodium isn't harmful but it's
    // not elegant, and we shouldn't force it just to chase fluid).
    const slt = sltSku || PRODUCTS.SLT_PLUS;   // V7-25: the athlete's chosen electrolyte (SLT+/SLT07/SLT05)
    const sodiumNeed = sodiumTargetMgH * durHrs;
    const fluidNeed = fluidTargetMlH * durHrs;
    const sodiumGap = sodiumNeed - totalSodium;
    const fluidGap = fluidNeed - totalFluid;
    const sltForSodium = sodiumGap > 0 ? Math.ceil(sodiumGap / slt.perUnit.sodiumMg) : 0;
    const sltForFluid  = fluidGap  > 0 ? Math.ceil(fluidGap  / slt.perUnit.fluidMl)  : 0;
    // V7-20: only top up with SLT+ if the athlete kept it in their product selection.
    let sltUnits = selSlt ? Math.max(sltForSodium, sltForFluid) : 0;
    // Sodium ceiling guard — back off if fluid-driven SLT+ would over-salt the plan.
    const sodiumCeiling = sodiumNeed * 1.5;
    while (sltUnits > 0 && (totalSodium + sltUnits * slt.perUnit.sodiumMg) > sodiumCeiling) {
      sltUnits--;
    }
    for (let s = 0; s < sltUnits; s++) {
      const t = Math.round(((s + 0.5) * (durHrs / Math.max(1, sltUnits))) * 60);
      pushEvent({
        timeMin: t,
        product: slt,
        qty: 1,
        carbs: 0,
        fluid: slt.perUnit.fluidMl,
        sodium: slt.perUnit.sodiumMg,
        caffeine: 0,
        label: 'Electrolyte',
        phase: 'in'
      });
    }

    // ── 2c. HYDRATION FLOOR ──
    // Never return an empty plan for a real session. When carbs genuinely aren't
    // needed (short easy effort — the duration scalar can legitimately drive the
    // carb target to ~0), the athlete still asked for a plan, so give them the
    // hydration essential: one SLT+. Keeps the bundle from ever showing £0 AND the
    // advice stays honest — "for this one, just hydrate" rather than force-feeding carbs.
    if (events.length === 0 && i.durationMin >= 30) {
      // V7-20: floor with a SELECTED product so we never add something the athlete
      // deselected. Prefer SLT+ (hydration), else any selected fuel, else SLT+.
      var floorProduct = sltSku
                       || gelMain || gelLight || mixSku || barSku || PRODUCTS.SLT_PLUS;
      pushEvent({
        timeMin: Math.round(i.durationMin / 2),
        product: floorProduct,
        qty: 1,
        carbs: floorProduct.perUnit.carbsG || 0,
        fluid: floorProduct.perUnit.fluidMl || 0,
        sodium: floorProduct.perUnit.sodiumMg || 0,
        caffeine: floorProduct.perUnit.caffeineMg || 0,
        label: floorProduct.perUnit.carbsG > 0 ? 'Fuel' : 'Electrolyte',
        phase: 'in'
      });
    }

    // Sort events by time (pre-race events stay first thanks to negative timeMin)
    events.sort(function (a, b) { return a.timeMin - b.timeMin; });

    // ── 3. SAFETY NET — final per-hour ceiling enforcement ──
    // If any hour still exceeds gutCeiling (edge cases), push the latest event forward.
    let pass = 0;
    while (pass < 10) {
      let breached = false;
      for (let h = 0; h < hours; h++) {
        const hStart = h * 60, hEnd = (h + 1) * 60;
        const inHour = events.filter(function (e) { return e.timeMin >= hStart && e.timeMin < hEnd && e.carbs > 0; });
        let sum = inHour.reduce(function (s, e) { return s + e.carbs; }, 0);
        while (sum > gutCeiling && inHour.length > 1) {
          const moved = inHour.pop();
          if (hEnd + 10 > i.durationMin - 15) {
            // No room left — drop the event entirely
            const idx = events.indexOf(moved);
            if (idx >= 0) events.splice(idx, 1);
          } else {
            moved.timeMin = hEnd + 10;
          }
          sum -= moved.carbs;
          breached = true;
        }
      }
      if (!breached) break;
      events.sort(function (a, b) { return a.timeMin - b.timeMin; });
      pass++;
    }

    // Recalculate running totals after redistribution (safety net may have dropped events)
    totalCarbs = 0; totalFluid = 0; totalSodium = 0; totalCaffeine = 0;
    events.forEach(function (e) {
      totalCarbs += e.carbs || 0;
      totalFluid += e.fluid || 0;
      totalSodium += e.sodium || 0;
      totalCaffeine += e.caffeine || 0;
    });

    /* BUNDLE ─────────────────────────────────── */
    // Tally events per product, round up to full retail packs.
    const productTally = {};
    events.forEach(function (ev) {
      const k = ev.product.key;
      productTally[k] = (productTally[k] || 0) + ev.qty;
    });

    const bundle = Object.keys(productTally).map(function (key) {
      const p = PRODUCTS[key];
      const unitsNeeded = productTally[key];
      const boxes = Math.max(1, Math.ceil(unitsNeeded / p.packSize));
      const totalUnits = boxes * p.packSize;
      const sessionsCovered = +(totalUnits / unitsNeeded).toFixed(1);
      return {
        key: key,
        product: p,
        unitsNeeded: unitsNeeded,
        boxes: boxes,
        totalUnits: totalUnits,
        sessionsCovered: sessionsCovered,
        lineTotal: +(boxes * p.price).toFixed(2)
      };
    }).sort(function (a, b) {
      // Sort by family role: drink → gel → bar → electrolyte
      const order = { 'drink-base': 1, 'drink-high': 1, 'drink-high-caf': 1, 'gel-carb': 2, 'gel-caf': 2, 'bar-solid': 3, 'electrolyte': 4 };
      return (order[a.product.role] || 9) - (order[b.product.role] || 9);
    });

    const bundleTotal = +bundle.reduce(function (sum, b) { return sum + b.lineTotal; }, 0).toFixed(2);

    /* REASONING ─────────────────────────────── */
    /* SCI-P0-1 / P0-3 / P1-6 / P1-7: reasoning now reflects duration + environment +
       goal modifiers so athletes can see why their number is what it is. */
    var durationBlurb = i.durationMin < 60
      ? 'short session means lower hourly intake (Jeukendrup 2014: <60 min sessions rarely benefit above 30 g/h)'
      : i.durationMin < 150
        ? 'session under 2.5 hours sits below the full gut tier ceiling'
        : 'session over 2.5 hours warrants the full gut tier target';
    var goalBlurb = goalMod.carbMult === 1.00 ? ''
                  : goalMod.carbMult < 1.00 ? ' Goal \u201c' + goalMod.label + '\u201d trims target by ' + Math.round((1 - goalMod.carbMult) * 100) + '%.'
                  : ' Goal \u201c' + goalMod.label + '\u201d pushes toward the gut ceiling (+' + Math.round((goalMod.carbMult - 1) * 100) + '%).';
    var envBlurb = env.factor === 1.00 ? ''
                 : env.factor < 1.00 ? ' Cool conditions trim estimated sweat by ' + Math.round((1 - env.factor) * 100) + '%.'
                 : ' ' + env.label.split(' (')[0] + ' conditions add ~' + Math.round((env.factor - 1) * 100) + '% to estimated sweat.';
    const reasoning = [];
    reasoning.push({
      n: 1,
      claim: 'Carb target ' + carbTargetGH + ' g/h matches your ' + gut.label.toLowerCase() + ' gut tier \u00d7 ' + intensity.label.toLowerCase() + ' intensity \u2014 ' + durationBlurb + '.' + goalBlurb,
      cites: [1, 3]
    });
    reasoning.push({
      n: 2,
      claim: 'STYRKR\u2019s 1:0.8 maltodextrin-to-fructose ratio enables ' + (carbTargetGH >= 90 ? 'multi-carb absorption above 60 g/h' : 'efficient absorption with reduced GI distress') + ' across the GEL50 and MIX range.',
      cites: [2]
    });
    reasoning.push({
      n: 3,
      claim: 'Fluid target ' + fluidTargetMlH + ' ml/h replaces ~70% of estimated sweat losses (' + sweatRate + ' ml/h). Over-drinking raises hyponatraemia risk; under-drinking hits 2% body-mass loss fast.' + envBlurb,
      cites: [4, 10]
    });
    reasoning.push({
      n: 4,
      claim: 'Sodium target ' + sodiumTargetMgH + ' mg/h reflects a ' + sodTier.label.toLowerCase() + ' sweat sodium profile. SLT+ tops up the gap that drink mix and gels alone don\u2019t close.',
      cites: [5, 10]
    });
    if (i.dietary === 'vegan') {
      reasoning.push({
        n: reasoning.length + 1,
        claim: 'Vegan-only filter active. Every product in your plan is plant-based \u2014 STYRKR\u2019s full range is vegan-friendly so no swaps were needed.',
        cites: [7]
      });
    }
    if (i.caffeine !== 'no') {
      /* SIM-R5 FIX: the 200-athlete sim found 28 plans (mostly heavier athletes)
         landing below the ISSN 3 mg/kg performance threshold because one or two
         caffeinated SKUs don't reach the dose. Flag it honestly rather than imply
         a performance benefit that isn't there. */
      var actualCafPerKg = totalCaffeine / i.weightKg;
      if (actualCafPerKg < 3 && totalCaffeine > 0) {
        reasoning.push({
          n: 5,
          claim: 'Caffeine total ' + totalCaffeine + ' mg works out to ' + actualCafPerKg.toFixed(1) + ' mg/kg — below the ISSN 3 mg/kg performance threshold. Fine for a gentle lift, but add a caffeinated gel near the business end if you want the full ergogenic effect.',
          cites: [6]
        });
      } else {
        reasoning.push({
          n: 5,
          claim: 'Caffeine total ' + totalCaffeine + ' mg (' + actualCafPerKg.toFixed(1) + ' mg/kg) sits in the ISSN 3–6 mg/kg performance range, capped at ' + cafCapMg + ' mg and ' + (i.caffeine === 'half' ? 'alternated to avoid late-stage stimulant overload.' : 'distributed across the session.'),
          cites: [6]
        });
      }
    }
    var hasBar = events.some(function (e) { return e.product.role === 'bar-solid'; });
    if (hasBar) {
      reasoning.push({
        n: reasoning.length + 1,
        claim: 'BAR50 added because session is over 2h and ' + sport.label + ' supports solid food — bars improve satiety and tolerance below race-pace.',
        cites: [8]
      });
    }
    if (isRace) {
      reasoning.push({
        n: reasoning.length + 1,
        claim: 'A pre-race GEL50 is scheduled 30 min before the gun to top up liver glycogen and stabilise blood glucose at the start.',
        cites: [7]
      });
    }

    /* CHART DATA ─────────────────────────────── */
    // Sampled every 5 min. Adds: intake vs oxidation, glycogen %, caffeine plasma,
    // hydration % loss, W'bal, bonk risk index.
    const chartTicks = [];

    // Fluid intake is sipped over the time the bottle is in use, not chugged at
    // the placement moment. Build per-bottle consumption windows so the hydration
    // chart reflects realistic gradual intake rather than instant delivery.
    const fluidEvents = events
      .filter(function (ev) { return ev.fluid > 0; })
      .map(function (ev) { return { timeMin: ev.timeMin, fluid: ev.fluid }; })
      .sort(function (a, b) { return a.timeMin - b.timeMin; });
    fluidEvents.forEach(function (ev, idx) {
      var next = fluidEvents[idx + 1];
      ev.windowMin = Math.max(1, (next ? next.timeMin : i.durationMin + 15) - ev.timeMin);
    });
    // Caffeine pharmacokinetic constants
    const cafHalfLifeMin = 5 * 60;            // ~5h plasma half-life
    const cafKe = Math.log(2) / cafHalfLifeMin; // elimination rate constant
    /* SCI-P2-9: glycogen baseline bumped from 12 → 15 g/kg muscle glycogen.
       Burke & Hawley 2018 (cite #9) document trained endurance athletes carry
       15–20 g/kg post carb-load. 12 understated by ~25% and made the glycogen
       chart curve too steep early in the session. */
    const glycogenStartG = 15 * i.weightKg;
    // Burn rate per minute at this intensity (approx kcal/min, then to glucose-equivalent g)
    // 75kg cyclist at steady = ~750 kcal/h → ~187 g glucose-equivalent/h (4 kcal/g) but only ~50-60% from CHO
    // Simplified: muscleGlycogenBurnRate (g/h) = intensity-driven, modulated by exogenous carb intake
    const baseGlycogenBurnGH = (carbTargetGH * 1.6) * intensity.carbMult;

    // ── W'bal model (cyclists/triathlon/MTB only) ──
    // Skiba 2012 simplified for planning view. W'₀ = anaerobic work capacity (kJ).
    // Skiba's regression on trained cyclists: W' typically 15–25 kJ, weak FTP correlation.
    // Banded by FTP tier so the number is honest rather than precise.
    const isCyclistish = ['road_cycle', 'offroad_cyc', 'triathlon'].indexOf(i.sport) >= 0;
    const wbalInitialKJ = (function () {
      if (!i.ftpW) return 20;                 // unknown FTP → trained athlete default
      if (i.ftpW >= 350) return 25;           // elite
      if (i.ftpW >= 280) return 22;           // strong amateur
      if (i.ftpW >= 220) return 19;           // trained recreational
      return 16;                              // beginner / lighter rider
    })();
    // Drain rate as fraction of W'₀ per hour at the planned intensity:
    // easy/steady stay below CP → no drain. Threshold sits at CP. Race-pace above CP.
    const wbalDrainPerHr = (
      i.intensity === 'race'      ? 0.20 :
      i.intensity === 'threshold' ? 0.10 :
      0.0
    );
    // Body mass in grams for hydration calc
    const bodyMassG = i.weightKg * 1000;
    // Respiratory water loss (~50 g/h, exhaled humidity)
    const respLossGH = 50;

    for (let t = preStartMin; t <= i.durationMin; t += 5) {
      let cumCarbsIntake = 0, cumSodium = 0, cumCaf = 0;
      events.forEach(function (ev) {
        if (ev.timeMin <= t) {
          cumCarbsIntake += ev.carbs;
          cumSodium += ev.sodium;
          cumCaf += ev.caffeine;
        }
      });
      // Fluid is distributed over each bottle's window — partial credit before window ends.
      let cumFluid = 0;
      fluidEvents.forEach(function (fe) {
        if (fe.timeMin > t) return;
        const elapsed = t - fe.timeMin;
        const fraction = Math.min(1, Math.max(0, elapsed / fe.windowMin));
        cumFluid += fe.fluid * fraction;
      });
      cumFluid = Math.round(cumFluid);

      // Oxidation only starts at t=0 (race start). Pre-race carbs sit in liver/gut.
      const tEffortMin = Math.max(0, t);
      const tHrs = tEffortMin / 60;
      const cumOxidationCap = carbTargetGH * tHrs;
      const cumOxidation = Math.min(cumCarbsIntake, cumOxidationCap);
      const inSystemCarbs = Math.max(0, cumCarbsIntake - cumOxidation);

      /* Glycogen depletion only starts at t=0.
         SIM-R7 FIX: the linear burn model made 3 ultra athletes finish below 5%
         glycogen (impossible — they'd have stopped). In reality, as a session
         extends past ~2h the body shifts toward fat oxidation, sparing muscle
         glycogen. We ramp burn DOWN by 5%/h after the 2h mark (floor 60% of base),
         and floor the remaining-glycogen reading at 8% — endurance athletes slow
         and fat-fuel rather than hit literal zero. */
      const fatOxFactor = tHrs > 2 ? Math.max(0.60, 1 - (tHrs - 2) * 0.05) : 1.0;
      const glycogenSpent = (baseGlycogenBurnGH * fatOxFactor * tHrs) - cumOxidation;
      const glycogenRemainingPct = Math.max(8, Math.min(100, 100 * (1 - Math.max(0, glycogenSpent) / glycogenStartG)));

      // Caffeine plasma: sum of (dose × decay since dose)
      let cafPlasma = 0;
      events.forEach(function (ev) {
        if (ev.caffeine > 0 && ev.timeMin <= t) {
          const dt = t - ev.timeMin;
          cafPlasma += ev.caffeine * Math.exp(-cafKe * dt);
        }
      });
      const cafPerKg = cafPlasma / i.weightKg;

      // Estimated losses (only after race start; pre-race window doesn't sweat)
      const lossFluid = (sweatRate / 60) * tEffortMin;
      const lossSodium = ((sweatRate / 1000) * sodTier.mgPerL / 60) * tEffortMin;
      // Estimated effort curve (relative power/pace as % of threshold)
      const effort = intensity.effortPct + (Math.sin(t / 30) * 3);

      /* ── Hydration % body-mass loss ──
         SIM-R6 FIX: the chart previously used cumFluid (fluid from STYRKR products
         only), which understated intake because athletes top up with plain water to
         hit the per-hour fluid target. The plan TELLS the athlete to drink
         fluidTargetMlH — the hydration trajectory should reflect following that
         guidance. We model planned intake = target rate, but never credit more than
         the products + a realistic water top-up could deliver, and never less than
         the product fluid itself. */
      const plannedFluidIntake = Math.max(cumFluid, fluidTargetMlH * tHrs);
      const hydrationLossG = lossFluid + respLossGH * tHrs - plannedFluidIntake;
      const hydrationLossPct = Math.max(0, 100 * hydrationLossG / bodyMassG);

      // ── W' balance (cyclistish only) ──
      // Fueling adequacy reduces drain by up to 50% — well-fueled riders defend W'.
      let wbalPct = 100;
      if (isCyclistish && tEffortMin > 0) {
        const target_so_far = carbTargetGH * tHrs;
        const fuelingEfficacy = Math.min(1, cumOxidation / Math.max(1, target_so_far));
        const wbalDrainFrac = wbalDrainPerHr * tHrs * (1 - fuelingEfficacy * 0.5);
        wbalPct = Math.max(0, Math.min(100, 100 * (1 - wbalDrainFrac)));
      }

      // ── Bonk Risk Index (composite) ──
      // 0–100. Weights: 40% glycogen depletion, 30% carb-intake gap, 20% intensity, 10% hydration.
      const carbGapFrac = tEffortMin > 0
        ? Math.max(0, (carbTargetGH * tHrs - cumCarbsIntake) / Math.max(1, carbTargetGH * tHrs))
        : 0;
      const intensityFactor = Math.max(0, intensity.carbMult - 1);
      const hydrationPenalty = Math.max(0, hydrationLossPct - 2) / 4;
      const bonkRisk = (
        0.40 * (1 - glycogenRemainingPct / 100) +
        0.30 * carbGapFrac +
        0.20 * intensityFactor +
        0.10 * hydrationPenalty
      );
      const bonkRiskPct = Math.max(0, Math.min(100, Math.round(bonkRisk * 100)));

      /* SCI-P1-8: carb deficit = target − actual intake at this point.
         Positive = behind schedule. Pre-race period contributes 0. */
      const targetCumulative = tEffortMin > 0 ? carbTargetGH * tHrs : 0;
      const carbDeficit = tEffortMin > 0
        ? Math.round(targetCumulative - cumCarbsIntake)
        : 0;

      chartTicks.push({
        timeMin: t,
        cumCarbsIntake: cumCarbsIntake,
        cumOxidation: Math.round(cumOxidation),
        inSystemCarbs: Math.round(inSystemCarbs),
        cumFluid: cumFluid,
        cumSodium: cumSodium,
        cumCaf: Math.round(cafPlasma),
        cafPerKg: +cafPerKg.toFixed(2),
        glycogenPct: Math.round(glycogenRemainingPct),
        lossFluid: Math.round(lossFluid),
        lossSodium: Math.round(lossSodium),
        effortPct: Math.round(effort * 10) / 10,
        // Advanced models
        wbalPct: +wbalPct.toFixed(1),
        hydrationLossPct: +hydrationLossPct.toFixed(2),
        bonkRiskPct: bonkRiskPct,
        carbDeficit: carbDeficit,       // SCI-P1-8
        // Legacy alias for backwards compat
        cumCarbs: cumCarbsIntake
      });
    }

    // Per-hour carb rate (with optional PRE bucket for race mode)
    const hourlyCarbs = [];
    if (isRace) {
      let preCarbs = 0;
      events.forEach(function (ev) { if (ev.timeMin < 0) preCarbs += ev.carbs || 0; });
      hourlyCarbs.push({ hour: 'PRE', label: 'Pre', carbs: preCarbs, isPre: true });
    }
    for (let h = 0; h < hours; h++) {
      let inHour = 0;
      events.forEach(function (ev) {
        if (ev.timeMin >= h * 60 && ev.timeMin < (h + 1) * 60) {
          inHour += ev.carbs;
        }
      });
      hourlyCarbs.push({ hour: h + 1, label: 'H' + (h + 1), carbs: inHour, isPre: false });
    }

    /* RETURN ─────────────────────────────────── */
    return {
      input: i,
      targets: {
        carbsGH: carbTargetGH,
        fluidMlH: fluidTargetMlH,
        sodiumMgH: sodiumTargetMgH,
        cafCapMg: cafCapMg,
        sweatRate: sweatRate,
        durationMin: i.durationMin,
        gutCeilingGH: gut.target,
        preStartMin: preStartMin,
        isRace: isRace
      },
      totals: {
        carbsG: totalCarbs,
        fluidMl: totalFluid,
        sodiumMg: totalSodium,
        caffeineMg: totalCaffeine
      },
      events: events,
      bundle: bundle,
      bundleTotal: bundleTotal,
      reasoning: reasoning,
      chart: { ticks: chartTicks, hourlyCarbs: hourlyCarbs },
      meta: {
        isCyclistish: isCyclistish,
        wbalInitialKJ: +wbalInitialKJ.toFixed(1),
        bodyMassG: bodyMassG
      },
      planId: 'STYRKR-FP-' + new Date().getFullYear() + '-' + Math.random().toString(36).substring(2, 8).toUpperCase()
    };
  }

  /* ─────────────────────────────────────────────
     EXPORT
  ───────────────────────────────────────────── */
  window.STYRKR_FUEL_V7_DATA = {
    CITATIONS: CITATIONS,
    PRODUCTS: PRODUCTS,
    DISCIPLINES: DISCIPLINES,
    INTENSITY: INTENSITY,
    GUT_TIERS: GUT_TIERS,
    SODIUM_TIERS: SODIUM_TIERS,
    generatePlan: generatePlan,
    version: '1.0.0'
  };

})(window);
